import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

const BASE = "/api/v1/access-system/zones";

/**
 * @param {*} res
 * @returns {object[]}
 */
export function unwrapZonesListResponse(res) {
  if (!res) return [];
  if (Array.isArray(res)) return res;
  if (res && Array.isArray(res.data)) return res.data;
  if (res && res.success === true && Array.isArray(res.data)) return res.data;
  return [];
}

/**
 * @param {*} res
 * @returns {object|null}
 */
export function unwrapZoneDetailResponse(res) {
  if (!res || typeof res !== "object") return null;
  if (res.data != null && typeof res.data === "object" && !Array.isArray(res.data)) {
    return res.data;
  }
  if (res.success === true && res.data != null && typeof res.data === "object") {
    return res.data;
  }
  if (res._id != null || res.id != null) {
    return res;
  }
  return res;
}

/**
 * GET /api/v1/access-system/zones
 * @returns {Promise<object[]>}
 */
export async function getAccessSystemZones() {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(BASE);
  return unwrapZonesListResponse(data);
}

/**
 * GET /api/v1/access-system/zones/:zoneId (if backend supports; else omit)
 * @param {string} zoneId
 */
export async function getAccessSystemZoneById(zoneId) {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `${BASE}/${encodeURIComponent(String(zoneId))}`,
  );
  return unwrapZoneDetailResponse(data);
}

/**
 * POST /api/v1/access-system/zones
 * @param {object} payload
 */
export async function createAccessSystemZone(payload) {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(BASE, payload);
  return unwrapZoneDetailResponse(data) ?? data;
}

/**
 * PUT /api/v1/access-system/zones/:zoneId
 * @param {string} zoneId
 * @param {object} payload
 */
export async function updateAccessSystemZone(zoneId, payload) {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.put(
    `${BASE}/${encodeURIComponent(String(zoneId))}`,
    payload,
  );
  return unwrapZoneDetailResponse(data) ?? data;
}

/**
 * DELETE /api/v1/access-system/zones/:zoneId
 * @param {string} zoneId
 */
export async function deleteAccessSystemZone(zoneId) {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(
    `${BASE}/${encodeURIComponent(String(zoneId))}`,
  );
  return data;
}
